var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4467 9.53337L14.18 12.8667C14.08 13.8867 14 14.6667 12.1933 14.6667H3.80665C1.99999 14.6667 1.91999 13.8867 1.81999 12.8667L1.55332 9.53337C1.49999 8.98004 1.67332 8.46671 1.98665 8.07337C1.99332 8.06671 1.99332 8.06671 1.99999 8.06004C2.36665 7.61337 2.91999 7.33337 3.53999 7.33337H12.46C13.08 7.33337 13.6267 7.61337 13.9867 8.04671C13.9933 8.05337 14 8.06004 14 8.06671C14.3267 8.46004 14.5067 8.97337 14.4467 9.53337Z",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33337 7.62V4.18667C2.33337 1.92 2.90004 1.35333 5.16671 1.35333H6.01337C6.86004 1.35333 7.05337 1.60667 7.37337 2.03333L8.22004 3.16667C8.43337 3.44667 8.56004 3.62 9.12671 3.62H10.8267C13.0934 3.62 13.66 4.18667 13.66 6.45333V7.64667",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28668 11.3334H9.71335",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.7e8817f9f856ab751db538514d1eafcd.svg";
export { ForwardRef as ReactComponent };